import { Skeleton } from '#/shared/ui/skeleton'

const COLUMN_WIDTHS = {
  vehicle: 'w-22',
  route: 'w-45',
  distance: 'w-22',
  listed: 'w-17',
  price: 'w-22',
  status: 'w-27',
  dispatched: 'w-22',
  actualPrice: 'w-25',
  action: 'w-30',
} as const

const ROW_COUNT = 5

function Cell({
  width,
  children,
  align = 'start',
}: {
  width: string
  children: React.ReactNode
  align?: 'start' | 'center'
}) {
  return (
    <div
      className={`flex items-center px-3.5 ${width} ${
        align === 'center' ? 'justify-center' : ''
      }`}
    >
      {children}
    </div>
  )
}

function PricePairSkeleton() {
  return (
    <div className="flex flex-col gap-1">
      <Skeleton className="h-3 w-12" />
      <Skeleton className="h-2.5 w-10" />
    </div>
  )
}

function RouteSkeleton() {
  return (
    <div className="flex flex-col gap-1">
      <Skeleton className="h-3 w-28" />
      <Skeleton className="h-3 w-24" />
    </div>
  )
}

function SkeletonRow() {
  return (
    <div className="flex items-center border-b border-gray-200 bg-white py-2.5">
      <Cell width={COLUMN_WIDTHS.vehicle}>
        <Skeleton className="h-3 w-10" />
      </Cell>
      <Cell width={COLUMN_WIDTHS.route}>
        <RouteSkeleton />
      </Cell>
      <Cell width={COLUMN_WIDTHS.distance}>
        <Skeleton className="h-3 w-12" />
      </Cell>
      <Cell width={COLUMN_WIDTHS.listed}>
        <Skeleton className="h-2.5 w-10" />
      </Cell>
      <Cell width={COLUMN_WIDTHS.price}>
        <PricePairSkeleton />
      </Cell>
      <Cell width={COLUMN_WIDTHS.status}>
        <Skeleton className="h-4 w-16 rounded-full" />
      </Cell>
      <Cell width={COLUMN_WIDTHS.dispatched}>
        <Skeleton className="h-2.5 w-12" />
      </Cell>
      <Cell width={COLUMN_WIDTHS.actualPrice}>
        <PricePairSkeleton />
      </Cell>
      <Cell width={COLUMN_WIDTHS.action} align="center">
        <Skeleton className="h-6 w-20 rounded-md" />
      </Cell>
    </div>
  )
}

export function MarketRateTableSkeleton() {
  return (
    <div className="flex flex-col">
      {Array.from({ length: ROW_COUNT }).map((_, index) => (
        <SkeletonRow key={index} />
      ))}
    </div>
  )
}
